import React,{ useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './HelpPage.css';


const faqs = [
{
question: "What is Custom Roam?",
answer: "Custom Roam is a personalized travel itinerary planner that helps you create detailed, multi-city travel plans with interactive maps, recommendations, and social sharing."
},
{
question: "What is Roam Share?",
answer: "Roam Share is our social travel feed where you can post photos/videos from your trips, view others’ journeys, and get inspired."
},
{
question: "Do I need to sign up to use Custom Roam?",
answer: "You can explore the homepage and basic features of generating and editing itinerary without signing in, but to save itineraries or share content, you'll need to create a free account."
},
{
question: "Is Custom Roam free to use?",
answer: "Yes! All core features of Custom Roam are free, including itinerary planning, Roam Share posting, and bucket list creation."
},
{
question: "Can I plan trips with multiple cities?",
answer: "Yes, Custom Roam supports multi-destination planning. Just enter your origin and all destination cities in the homepage form."
},
{
question: "Can I use Custom Roam on mobile devices?",
answer: "Yes, Custom Roam is fully mobile-responsive. A dedicated mobile app is also coming soon!"
},
{
question: "How do I generate an itinerary?",
answer: "Enter your trip details on the homepage (origin, destination, trip type, dates, pace), and click Generate Itinerary, You’ll be redirected to a page with route and day-by-day details."
},
{
question: "Can I customize my itinerary after it's generated?",
answer: "Absolutely. You can edit timings, swap attractions between days, delete or add new attractions, and reorder them easily using dropdown controls."
},
{
question: "Can I share my itinerary with friends or family?",
answer: " Absolutely. Each itinerary comes with a unique shareable link that you can send to others so they can view your plan without needing to log in."
},
{
question: "Can I access Custom Roam from a different device?",
answer: "Yes! As long as you’re logged into your account, you can access your trips, Roam Share posts, and preferences from any device—laptop, tablet, or phone."
},
{
question: "Can I save my itinerary for later?",
answer: "Yes. Click “Save Itinerary” to store it under your account. You can revisit or edit it anytime from your My Itineraries section."
},
{
question: "What is the Explore section in the itinerary page?",
answer: "It's a dynamic discovery space below your itinerary that shows recommended attractions in the current city. You can add them directly to your itinerary."
},
{
question: "Can I search for specific attractions?",
answer: "Yes, use the search bar in the Explore section to find attractions by keyword (e.g., aquarium) across your current and nearby cities."
},
{
question: "Can I change the duration or time spent for each attraction?",
answer: "Yes, every itinerary card includes dropdowns to change visit duration, day, and time to fully customize your schedule."
},
{
question: "Can I post both images and videos?",
answer: "You can create either a photo post (up to 10 images) or a single video post (with maximum duration of 3mins). Mixed media posts are not supported yet."
},
{
question: "How do I create a Roam Share post?",
answer: "Go to the profile tab → click new Post → upload photos or video, write a caption, choose a location, add tags, and publish."
},
{
question: "What are tags used for?",
answer: "Tags like adventure sports or scenic views help categorize posts. Users can filter the Roam Share feed by these tags to find relevant content."
},
{
question: "Can I edit or delete my Roam Share post?",
answer: "Yes, go to your profile → click the 3-dot menu (⋯) on your post → choose Edit or Delete."
},
{
question: "How do I set or change my username?",
answer: "Go to your Profile page. If you haven’t set a username, click + Set your username. You can only set it once, and it must be unique."
},
{
question: "Can I update my profile picture or description?",
answer: "Yes. Click Edit Profile to change your profile picture or bio anytime."
},
{
question: "What is the Bucket List feature?",
answer: "The Bucket List page allows you to create personal travel checklists with destinations and target dates. You can track progress and mark items as complete."
},
{
question: "Is my data safe on Custom Roam?",
answer: "Yes. We use secure authentication and encrypted storage to protect your data. Your information is never shared with third parties without consent."
},
{
question: "Can I reset my password or recover my account?",
answer: "Yes, click “Forgot Password?” on the login page. You’ll receive an OTP to your registered email to reset your password."
},
];


const HelpPage = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

return (
<div>
<div className="header">
            <div className="brand" onClick={() => navigate("/")}>
            <img src="/images/customroam-logo.png" alt="Logo" className="logo-img" />
            <span className="brand-text">CUSTOM ROAM</span>
             </div>
              {/* Hamburger menu button */}
              <button className="header-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
                ☰
               </button>
             <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
                    <span className="nav-link" onClick={() => navigate('/')}>Home</span>
                    <span className="nav-link" onClick={() => navigate('/roam-share')}>Roam Share</span>
                    <span className="nav-link" onClick={() => navigate('/my-itineraries')}>My Itineraries</span>
                    <span className="notification-icon" onClick={() => navigate('/notifications')}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                       height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                     className="bell-svg"
                    >
                        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
                         <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                    </svg>
                 </span>
                    <span className="nav-link" onClick={() => navigate('/profile')}>Profile</span>
                </div>
            </div>
<div className="help-page">
  <div className='heading'>
<h1>Contact Us</h1>
</div>
<p>For any queries, suggestions, or feedback, feel free to reach out to us at <strong>support@customroam.com</strong> — we're always happy to hear from you and improve your experience with Custom Roam.</p>
<div className='heading'>
<h1>Frequently Asked Questions</h1>
</div>
<div className="faq-list">
{faqs.map((faq, index) => (
<div className="faq-item" key={index}>
<h3 className="faq-question">{faq.question}</h3>
<p className="faq-answer">{faq.answer}</p>
</div>
))}
</div>
</div>
</div>
);
};


export default HelpPage;